import "./PrivacyPolicy.css";
const PrivacyPolicy = () => {
  return (
    <div id="privacyPolicy_container">
      <h2>Privacy Policy</h2>

      <p>
        Sri Mandeswaraswamy Temple is committed to being transparent and fair
        when we collect and use your personal information and to complying with
        the data protection laws that apply in the countries where we
        operate.&nbsp;&nbsp;
      </p>

      <p>
        Should you have any questions about this Notice, please let us know by
        contacting us at the email at aceomandapalli@gmail.com&nbsp;
      </p>

      <p>
        <h4>When does this notice apply?&nbsp;</h4>
      </p>

      <p>
        This Privacy Notice applies to all personal data that Sri
        Mandeswaraswamy Temple processes during the execution of its business
        activities, including data related to your use of this website. Sri
        Mandeswaraswamy Temple has adopted the principles and requirements of
        the European Union’s General Data Protection Regulation (GDPR) as the
        basis for its privacy practices.&nbsp;
      </p>

      <p>Third-party websites &nbsp;</p>

      <p>
        Unless stated otherwise, this Notice does not apply to any third-party
        sites that may link to, or be accessible from, our websites. A link does
        not constitute endorsement of the content, viewpoints, accuracy,
        opinions, policies, products, services, or accessibility of that
        website. If you choose to follow a link to another website, you are
        subject to the terms and conditions of that website, including its
        privacy policy.&nbsp;&nbsp;
      </p>

      <p>
        <h4>What personal data do we collect?&nbsp;</h4>
      </p>

      <p>
        We collect only the personal data needed to advance our mission. For
        example, we collect personal data of study subjects as disclosed in
        informed consents when we are the sponsor of clinical trials or social
        and behavioral science research studies, and we collect personal data of
        donors in support of our fundraising activities. We also collect
        personal data of candidates, employees, and people with whom we work to
        the extent that it is needed to carry out standard business activities
        such as hiring and employing individuals or administering grants and
        contracts. We are committed to limiting personal data collection to what
        is necessary for a particular purpose.&nbsp;&nbsp;
      </p>

      <p>Information You Provide&nbsp;</p>

      <p>
        We collect certain personal data when you voluntarily provide it, either
        directly to us or via third-party vendors with whom we work to provide
        our services. The type of personal data we collect from you depends on
        how you interact with us. You can choose not to provide personal data
        when asked for it, but it may restrict our ability to provide you with
        some services you have requested. Examples of personal information you
        may provide include:&nbsp;
      </p>

      <ul>
        <li>
          Contact information and areas of interest if you donate to us or
          choose to receive newsletters, updates, or other information from
          us&nbsp;&nbsp;
        </li>

        <li>
          Personal or health information if you participate in a research study
          or a clinical trial with us&nbsp;&nbsp;
        </li>

        <li>
          Personal, educational and professional information if you apply for a
          position with us&nbsp;&nbsp;
        </li>

        <li>
          Personal data you include if you email, text, or instant message us,
          or contact us through forms on our sites&nbsp;
        </li>

        <li>
          Personal data contained in any proposal documents, feedback, comments,
          photos, videos, or other information you provide to us in the course
          of our business activities&nbsp;&nbsp;
        </li>
      </ul>

      <p>Donor information&nbsp;&nbsp;</p>

      <p>
        Personal data of donors is provided to us directly by donors or via
        third-parties that collect or process donations. This personal data
        includes name and contact information, amounts and dates of donations,
        subscription interests, and in some circumstances also includes honor or
        memoriam information, employer information, familial relationship
        information, and/or publicly available wealth information collected by
        us. If you choose to make donations through third-party donation
        processors, please be sure to review any linked policies provided during
        payment processing as they will apply to you. Sri Mandeswaraswamy Temple
        does not store any donor credit card information. Except for vendors
        that we work with to process and manage donations and data, and which
        are bound by strict confidentiality obligations, we do not share donor
        information with third parties. Sri Mandeswaraswamy Temple does not sell
        donor data.&nbsp;&nbsp;
      </p>

      <p>Information collected through this website &nbsp;</p>

      <p>
        Like most website operators, we collect information that web browsers
        and servers typically make available, such as the browser type, language
        preference, referring site and the date and time of each visitor
        request. Sri Mandeswaraswamy Temple’s purpose in collecting this
        non-personally identifying information is to better understand how our
        visitors use the website, so we can improve the experience for
        everyone.&nbsp;&nbsp;
      </p>

      <p>
        <h4>Website cookies&nbsp;</h4>
      </p>

      <p>
        A cookie, and similar technology such as a pixel, is a small text file
        that a website stores on your computer. A cookie can capture information
        about your browser and browser activity, such as device and browser
        information, IP address, general geographic location, access time and
        date, and previously visited websites. You can find information about
        cookies at www.aboutcookies.org.&nbsp;&nbsp;
      </p>

      <p>
        We use certain strictly necessary cookies to make our websites work.
        Necessary cookies help make a website usable by enabling basic functions
        like page navigation and access to secure areas of the website. The
        website cannot function properly without these cookies. We use
        functional cookies to enable functions such as sharing content. We also
        use analytics and performance cookies to help understand how visitors
        are using our website and how the website is performing, in order to
        improve the website experience. Finally, we may use third-party
        advertising and marketing cookies that provide visitors with customized
        advertising based on their web-browsing history and to analyze
        effectiveness of ad campaigns.&nbsp;
      </p>

      <p>
        Cookies can be managed or blocked through your browser. However, if your
        browser is set to block cookies, you may have some trouble accessing
        certain parts or functionalities on our sites. If the site has a “Manage
        Cookies” button, you can view, change and manage your cookie settings at
        any time. If the site does not have a “Manage Cookies” button, and you
        have not set your browser to block cookies, then your continued use of
        the site represents your consent to cookies and similar
        technologies.&nbsp;&nbsp;
      </p>

      <p>
        <h4>Click-through URLs&nbsp;</h4>
      </p>

      <p>
        If you subscribe to our newsletters, our emails may use a “click-through
        URL” linked to content on our sites. When you click one of these URLs,
        they pass through a separate web server before arriving at the
        destination page on our sites. We use this click-through data to help us
        understand how recipients respond to, or interact with, our
        emails.&nbsp;
      </p>

      <p>
        <h4>Social media and video sites&nbsp;</h4>
      </p>

      <p>
        If you choose to share our content through social media networks like
        Facebook, Twitter and LinkedIn or watch one of our videos on a media
        site like YouTube, those third-party sites may place cookies on your
        computer. We do not control these cookies. Please check those sites for
        information about their use of cookies and how to manage them.&nbsp;
      </p>

      <p>
        <h4>How do we use or process personal data?&nbsp;</h4>
      </p>

      <p>Sri Mandeswaraswamy Temple may process personal data:&nbsp;</p>

      <ul>
        <li>To undertake email actions &nbsp;</li>

        <li>To send you newsletters, if you choose to subscribe &nbsp;</li>

        <li>To ask you to donate or get involved in our campaigns&nbsp;</li>

        <li>To process donations that we receive from you&nbsp;</li>

        <li>To administer your application for employment &nbsp;</li>
      </ul>

      <ul>
        <li>To improve our website &nbsp;</li>

        <li>To conduct budgeting and financial audits&nbsp;</li>

        <li>To establish contractual or other business engagements&nbsp;</li>

        <li>To conduct scientific research studies&nbsp;&nbsp;</li>

        <li>
          To develop safety reports for clinical trials and products&nbsp;
        </li>
      </ul>

      <ul>
        <li>
          To conduct and share statistical analyses of scientific research
          data&nbsp;
        </li>

        <li>
          To contribute to our archive of information in the public
          interest&nbsp;
        </li>

        <li>
          To fulfill any legal obligations or to comply with the law&nbsp;
        </li>
      </ul>

      <p>
        <h4>What is the basis for processing personal data?&nbsp;</h4>
      </p>

      <p>
        Depending on the type of data provided, we may process your personal
        data based on:&nbsp;
      </p>

      <p>
        <h4>Your consent. </h4>We may process your personal data for a specific
        purpose after obtaining your consent. Where we are relying on consent as
        the legal basis, we will notify you and seek additional consent before
        using your personal data for any purpose different from the original
        purpose. Although there are some exceptions, you have the right to
        withdraw your consent at any time, by contacting us at the email or
        addresses listed below in the section titled, “How to contact us.”&nbsp;
      </p>

      <p>
        <h4>Legitimate interest. </h4>We may process your personal data to
        fulfill our legitimate interest in achieving our mission.&nbsp;&nbsp;
      </p>

      <p>
        <h4>To fulfill a contractual obligation. </h4>If you engage with us, we
        will process the personal data you provide solely for the execution of
        the business activities associated with the engagement. &nbsp;
      </p>

      <p>
        <h4>Legal obligation. </h4>Sri Mandeswaraswamy Temple may disclose
        personal information in response to subpoenas, court orders or other
        legal process, to establish, exercise or defend our legal rights and to
        process a data subject’s request.&nbsp;
      </p>

      <p>
        <h4>Is your personal data shared?&nbsp;</h4>
      </p>

      <p>
        We may share your personal data with our employees, contractors and
        agents, as well as with third-party vendors and service providers, only
        as needed for the purposes listed in this Notice. If we share your
        personal data with third parties as described, we require that they
        comply with applicable data protection laws. We may share information
        with your consent or at your direction, such as when you choose to share
        information on our websites. We do not sell personal data to any
        third-party for marketing purposes.&nbsp;
      </p>

      <p>
        <h4>Where is your personal data stored or transferred?&nbsp;&nbsp;</h4>
      </p>

      <p>
        Your personal data may be stored, processed, or transferred in and to
        any other country where we or our service providers have facilities. We
        take appropriate steps to ensure that your legal rights and protections
        travel with any such transfer of your personal data as required by
        applicable law. When necessary under applicable law, we ensure
        appropriate safeguards for protecting your personal data are in
        place.&nbsp;&nbsp;
      </p>

      <p>
        <h4>How long will your personal data be stored for?&nbsp;</h4>
      </p>

      <p>
        We hold your personal data in our systems only for as long as necessary
        for the purposes listed in this Notice. We remove personal data from our
        systems once it is no longer required, in line with our guidelines on
        how long important information must remain accessible for future use or
        reference. The length of time each category of data will be retained
        will vary depending on the length of time required to process it, the
        reason it was collected, and to comply with any statutory requirements.
        After this time, the data will either be deleted or we may retain a
        secure anonymized record for research and analytical purposes.&nbsp;
      </p>

      <p>
        <h4>What data privacy rights do you have?&nbsp;</h4>
      </p>

      <p>
        Under GDPR, you have the right, subject to applicable local data
        protection legislation, to:&nbsp;
      </p>

      <ul>
        <li>
          Withdraw your consent, when the collection and use of your personal
          data was based solely on your consent&nbsp;
        </li>

        <li>
          Request access to, and receive a copy of the personal data we
          hold&nbsp;
        </li>

        <li>
          Request correction or erasure of the personal data that are
          inaccurate&nbsp;
        </li>
      </ul>

      <ul>
        <li>
          Request the deletion of personal data in certain circumstances, such
          as withdrawal of consent or when the data is no longer necessary for
          the purpose for which it was collected or processed&nbsp;
        </li>

        <li>
          Restrict processing of personal data where the accuracy of the
          personal data is contested, the processing is unlawful, or if the data
          subjects have objected to the processing&nbsp;&nbsp;
        </li>

        <li>
          Receive or have transferred to another processor the personal data in
          structured, commonly used and machine-readable format&nbsp;&nbsp;
        </li>

        <li>
          Object to processing for direct marketing, or to processing for
          scientific/historical research/statistical purposes&nbsp;
        </li>
      </ul>

      <p>
        Even if you object to the processing of personal data, we are
        nevertheless allowed to continue the same if the processing is (i)
        legally mandatory, (ii) necessary for the performance of a contract to
        which you are a party, (iii) necessary for the performance of a task
        carried out in the public interest, or (iv) necessary for the purposes
        of the legitimate interests we follow, including the establishment,
        exercise or defense of legal claims. &nbsp;
      </p>

      <p>
        Under South Africa’s Protection of Personal Information Act (POPIA), you
        have the right to have your personal information processed in accordance
        with the conditions for the lawful processing of personal information,
        including the right-&nbsp;
      </p>

      <ul>
        <li>To be notified that—&nbsp;</li>
      </ul>

      <ul>
        <li>personal information about you is being collected; or&nbsp;</li>

        <li>
          personal information has been accessed or acquired by an unauthorized
          person&nbsp;
        </li>

        <li>
          To establish whether your personal information has been collected and
          to request access to your personal information&nbsp;
        </li>
      </ul>

      <ul>
        <li>
          To request, where necessary, the correction, destruction or deletion
          of your personal information&nbsp;
        </li>

        <li>
          To object, on reasonable grounds relating to your particular
          situation, to the processing of your personal information&nbsp;
        </li>

        <li>
          To object to the processing of your personal information for purposes
          of direct marketing&nbsp;
        </li>

        <li>
          Not to have your personal information processed for purposes of direct
          marketing by means of unsolicited electronic communications except
          where consent was given;&nbsp;
        </li>

        <li>
          Not to be subject, under certain circumstances, to a decision that is
          based solely on the basis of the automated processing of your personal
          information for profiling purposes&nbsp;
        </li>
      </ul>

      <ul>
        <li>
          To submit a complaint to the Regulator regarding the alleged
          interference with the protection of the personal information of any
          data subject or to submit a complaint to the Regulator in respect of a
          determination of an adjudicator&nbsp;&nbsp;
        </li>

        <li>
          To institute civil proceedings regarding the alleged interference with
          the protection of your personal information&nbsp;&nbsp;
        </li>
      </ul>

      <p>
        Subject to the limitations set forth herein and/or in applicable local
        data protection laws, you can exercise the above rights by contacting
        Sri Mandeswaraswamy Temple.&nbsp;&nbsp;
      </p>

      <p>
        <h4>How to contact us&nbsp;</h4>
      </p>

      <p>
        Please direct all data privacy requests and inquiries to:
        <h4> aceomandapalli@gmail.com </h4> Please be sure to provide the
        following information when contacting us: First &amp; Last Name/
        Business Name, and Email Address&nbsp;
      </p>

      <p>
        On receiving your communication, we are likely to request evidence of
        your identity to ensure your personal data and information connected
        with it is not provided to anyone other than you. &nbsp;
      </p>

      <p>
        <h4>Effective date&nbsp;</h4>
      </p>

      <p>
        The effective date of this page is November 29, 2023. Sri
        Mandeswaraswamy Temple reserves the right to amend this policy from time
        to time at its sole discretion. We encourage visitors to frequently
        check this page for any changes to the Privacy Notice. Your continued
        use of our services and of this site after any change in this Privacy
        Notice will constitute your acceptance of such changes.&nbsp;
      </p>
    </div>
  );
};
export default PrivacyPolicy;
